export const NoOffersMessages = {
  noOffers: {
    id: 'Pages.Consumer.Post.Submission.Offers.View.NoOffers',
    description: 'Message indicating no offers available',
  },
}
